"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createQuantityUpgradesPayload = void 0;

var _ImmutableMerchandiseIdMap = _interopRequireDefault(require("self-service-api/constants/ImmutableMerchandiseIdMap"));

var createQuantityUpgradesPayload = function createQuantityUpgradesPayload(itemConfigurations) {
  return itemConfigurations.map(function (itemConfiguration) {
    var quantityMultiplier = _ImmutableMerchandiseIdMap.default[itemConfiguration.merchandiseId].quantityMultiplier;
    var calculatedQuantity = Math.ceil(itemConfiguration.quantity / quantityMultiplier);
    itemConfiguration.quantity = calculatedQuantity;
    return itemConfiguration;
  });
};

exports.createQuantityUpgradesPayload = createQuantityUpgradesPayload;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/core/utilities/createQuantityUpgradesPayload.js
// module id = 722
// module chunks = 5 6